import { Injectable } from '@angular/core';
import { IIntegratedCare } from '@pia/pia.shared';
import { BaseStateExtension } from 'src/app/common/state/state-extension';
import { IntegratedCareModelName } from 'src/app/shared/models/model-names';
import { IntegratedCareViewModel } from './integratedcare-view-model';

@Injectable({ providedIn: 'root' })
export class IntegratedCareStateExtension extends BaseStateExtension<IIntegratedCare> {
  public get name(): string {
    return IntegratedCareModelName;
  }

  // eslint-disable-next-line require-await
  async canBeStored(_item: IIntegratedCare): Promise<boolean> {
    return true;
  }

  protected afterCreateInternal(_item: IIntegratedCare): void {}

  protected async afterUpdateInternal(item: IIntegratedCare): Promise<void> {
    if (
      this.stateRegistry.get<IIntegratedCare, IntegratedCareViewModel>(IntegratedCareModelName, 'selectedItem')?._id ===
      item?._id
    ) {
      await this.stateRegistry.update(IntegratedCareModelName, 'selectedItem', item);
    }
  }

  protected removeFromState(_item: IIntegratedCare): void {}
}
